module.exports = __webpack_public_path__ + "static/img/ip_boy@2x.b07830c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FPS/ip_boy@2x.png
// module id = t2Cz
// module chunks = 1